import { z } from "zod"
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"
import type { TypedSchemaOutput } from "@/utils/typeUtils"
import {
  emailAddressSchema,
  requiredTrimmedString,
} from "@/validation/sharedStringFieldSchemas"

const createEditUserFormSchema = z.object({
  firstName: requiredTrimmedString(
    "First name is required"
  ).max(150, "Must be 150 characters or fewer"),
  lastName: requiredTrimmedString(
    "Last name is required"
  ).max(150, "Must be 150 characters or fewer"),
  email: emailAddressSchema("Email is required").max(
    150,
    "Must be 150 characters or fewer"
  ),
  role: requiredTrimmedString("Role is required").max(
    32,
    "Must be 32 characters or fewer"
  ),
})

export type CreateEditUserFormOutput = TypedSchemaOutput<
  typeof createEditUserFormSchema
>

export const useCreateEditUserForm = () =>
  useForm({
    validationSchema: toTypedSchema(
      createEditUserFormSchema
    ),
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
    },
  })
